import { createAction } from '@reduxjs/toolkit';

export const userSettingsRequest = createAction('userSetting/request');
export const userSettingsError = createAction('userSetting/error');
export const userSettingsStore = createAction('userSetting/store');
export const userSettingsStoreEntitlements = createAction('userSetting/storeEntitlements');

export const userSettingUpdateCurrency = createAction('userSetting/updateCurrency');
export const userSettingUpdateApiKey = createAction('userSetting/updateApiKey');
